import { useLocation } from "react-router-dom"
import { SEO } from "./Seo"
import { DEFAULT_SEO_DESCRIPTION } from "./seoConfig"
import { isStorePublicTrackingPath } from "../analytics/trackingRoutes"

const publicPathPatterns = [
  /^\/$/,
  /^\/criar-loja-virtual$/,
  /^\/loja-virtual-gratis$/,
  /^\/vender-online$/,
  /^\/plataforma-ecommerce$/,
  /^\/como-funciona$/,
  /^\/lojas$/,
  /^\/catalogo-digital-publico$/,
  /^\/catalogo-pronto-gratis$/,
  /^\/quiz(\/[a-z0-9-]+)?$/,
  /^\/courier$/,
  /^\/seja-um-revendedor$/,
  /^\/terms-of-service$/,
  /^\/privacy-policy$/,
  /^\/refund-policy$/,
  /^\/cancellation-policy$/,
]

export const SeoRouteGuard = () => {
  const { pathname } = useLocation()

  const isMarketingRoute = publicPathPatterns.some((pattern) => pattern.test(pathname))
  const isStorePublicMenu = isStorePublicTrackingPath(pathname)

  const isPublicPath = isMarketingRoute || isStorePublicMenu

  return (
    <SEO
      title="Crie sua loja virtual e venda online"
      description={DEFAULT_SEO_DESCRIPTION}
      path={pathname}
      noindex={!isPublicPath}
    />
  )
}
